(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/mobile/components/mobile-confirm.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/react/pages/my-information/my-information-panel/mobile/components/mobile-confirm.js');
'use strict';

const Button = svs.ui.ReactButton;
const {
  Form,
  Inputv2,
  ControlGroup
} = svs.ui.reactForm;
const {
  postConfirmMobileNumber,
  getCustomersPreferences,
  setForceSaveMobile
} = svs.myProfile.react.store.pdPreferences.actions;
const {
  FULFILLED,
  REJECTED
} = svs.myProfile.constants.thunkStatus;
const {
  putSendMobileVerificationCodeAsync
} = svs.myProfile.react.pages.myInformation.myInformationService;
const {
  showTechnicalError,
  showMobileConfirmedDialog,
  showMobileConfirmedFlash,
  showMobileVerificationCodeSent
} = svs.myProfile.react.shared.dialogs;
const DEFAULT_ERROR_MESSAGE = 'Koden ska bestå av fyra siffror.';
const trackEventVerify = (verify, callback) => {
  const track = {
    category: 'My Profile',
    action: 'mobile verify',
    opt_label: verify ? 'Yes' : 'No'
  };
  if (callback) {
    svs.components.analytics.trackEvent(track, callback);
  } else {
    svs.components.analytics.trackEvent(track);
  }
};

const MobileConfirm = () => {
  const dispatch = ReactRedux.useDispatch();
  const location = ReactRouterDOM.useLocation();
  const {
    cellphone,
    cid
  } = ReactRedux.useSelector(state => state.playerPreferences.playerPreferences);
  const {
    status: playerPreferencesStatus
  } = ReactRedux.useSelector(state => state.playerPreferences.playerPreferencesStatus);
  const [code, setCode] = React.useState('');
  const [inputErrorMessage, setInputErrorMessage] = React.useState(DEFAULT_ERROR_MESSAGE);
  const [isInputError, setIsInputError] = React.useState(false);
  const [returnUrl, setReturnUrl] = React.useState('');
  React.useEffect(() => {
    dispatch(getCustomersPreferences());
  }, [dispatch]);
  React.useEffect(() => {
    var _queryStringObject;
    let queryStringObject = svs.utils.url.queryString;
    if ('URLSearchParams' in window) {
      const urlParamsFunctions = new URLSearchParams(location.search);
      queryStringObject = {
        returnUrl: urlParamsFunctions.get('returnUrl'),
        cancelUrl: urlParamsFunctions.get('cancelUrl')
      };
    }
    if ((_queryStringObject = queryStringObject) !== null && _queryStringObject !== void 0 && _queryStringObject.returnUrl) {
      setReturnUrl(queryStringObject.returnUrl);
    }
  }, [location.search]);
  React.useEffect(() => {
    if (playerPreferencesStatus === FULFILLED || playerPreferencesStatus === REJECTED) {
      if (!cid) {
        showTechnicalError();
      }
    }
  }, [cid, playerPreferencesStatus]);
  const navigateToReturnUrl = () => {
    svs.utils.url.navigate(svs.utils.url.makeInternal(returnUrl, svs.core.urlMapping.get('startPage')));
  };

  const setInputErrorAndMessage = message => {
    setInputErrorMessage(message);
    setIsInputError(true);
  };

  const handleMobileConfirmError = errorCode => {
    switch (errorCode) {
      case null:
        break;
      case 12520:
        setInputErrorAndMessage('Koden du angav är gammal.');
        break;
      case 12500:
        setInputErrorAndMessage('Koden du angav är felaktig. Prova igen eller skicka ny kod');
        break;
      case 12510:
        showTechnicalError('Dit mobilnummer är redan verifierat', () => {
          navigateToReturnUrl();
        });
        break;
      default:
        svs.myProfile.logger.debug("Unhandled error code when confirming verification sms: ".concat(code));
        showTechnicalError('Ett fel inträffade när koden skulle verifieras, försök igen senare eller kontakta Kundservice 0770 - 11 11 11');
    }
  };

  const handleInputCodeChange = e => {
    if (e.target.value.length <= 4) {
      setCode(e.target.value);
    }
  };

  const handleSendNewCodeClick = async () => {
    try {
      const {
        error
      } = await putSendMobileVerificationCodeAsync();
      if (error) {
        switch (error) {
          case 12010:
            showTechnicalError();
            break;
          case 12015:
            showTechnicalError();
            break;
          case 12016:
            setIsInputError(true);
            break;
          case 12017:
            showTechnicalError();
            break;
          default:
        }
      } else {
        showMobileVerificationCodeSent(cellphone);
      }
    } catch (error) {
      svs.myProfile.logger.warn("Unhandled error code when confirming verification sms: ".concat(error.code));
      showTechnicalError();
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (isNaN(code) || code.length !== 4) {
      setInputErrorMessage(DEFAULT_ERROR_MESSAGE);
      setIsInputError(true);
      return;
    }
    const result = await dispatch(postConfirmMobileNumber(code));
    if (RTK.isFulfilled(result)) {
      if (returnUrl) {
        showMobileConfirmedFlash(cellphone, returnUrl);
        trackEventVerify(true, navigateToReturnUrl);
      } else {
        trackEventVerify(true);
        showMobileConfirmedDialog(cellphone, () => {});
      }
    } else {
      handleMobileConfirmError(result === null || result === void 0 ? void 0 : result.payload.error);
    }
  };
  showMobileConfirmedFlash(cellphone, returnUrl);

  const setForceSaveTrue = () => {
    dispatch(setForceSaveMobile(true));
  };
  return React.createElement("div", null, playerPreferencesStatus === FULFILLED && React.createElement(React.Fragment, null, React.createElement(Form, {
    onSubmit: handleSubmit
  }, React.createElement(ControlGroup, {
    errorMessage: inputErrorMessage,
    hasError: isInputError,
    isLessSpace: true,
    v2: true
  }, React.createElement(Inputv2, {
    autoComplete: "off",
    id: "smsCode",
    inputHelpText: "4 siffror 0-9",
    label: "Ange kod fr\xE5n SMS",
    name: "sms code",
    onChange: handleInputCodeChange,
    value: code
  })), React.createElement(Button, {
    className: "w100 margin-v-1",
    id: "submitSmsCode",
    inverted: true,
    size: 300,
    type: "submit"
  }, "Bekr\xE4fta")), React.createElement(Button, {
    block: true,
    className: "margin-v-1",
    onClick: handleSendNewCodeClick,
    transparent: true
  }, "Skicka ny kod"), React.createElement(Button, {
    block: true,
    id: "forceSave",
    onClick: setForceSaveTrue,
    transparent: true
  }, "Ange nytt mobilnummer")));
};
svs.myProfile.react.pages.myInformation.myInformation.mobile.MobileConfirm = MobileConfirm;

 })(window);